// extracted by mini-css-extract-plugin
module.exports = {"dot":"_9a38B","blink":"_2p39U"};